import React from "react";

function Loading() {
  return (
    <div className="loading-component mb-5">
      <div className="loader"></div>
    </div>
  );
}

export default Loading;
